export const convertDate = (date: Date) =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

export const cutText = (text: string, charLength: number = 100) =>
  text.length > charLength ? `${text.slice(0, charLength)}...` : text;
